import { oldBaseApi } from "../../api";
import { toFilestoreRequestPath } from "./filestore-path";

export async function fetchFilestoreFileBlob(documentPath: string): Promise<Blob> {
  const response = await oldBaseApi.get(toFilestoreRequestPath(documentPath), {
    responseType: "blob",
  });

  if (!(response.data instanceof Blob) || response.data.size === 0) {
    throw new Error("Не удалось загрузить документ");
  }

  return response.data;
}
